import { render, staticRenderFns } from "./createKnowledgeBaseDoc.vue?vue&type=template&id=56745844&scoped=true"
import script from "./createKnowledgeBaseDoc.vue?vue&type=script&lang=js"
export * from "./createKnowledgeBaseDoc.vue?vue&type=script&lang=js"
import style0 from "./createKnowledgeBaseDoc.vue?vue&type=style&index=0&id=56745844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56745844",
  null
  
)

export default component.exports